
export class HEC_CONSTANTS {

	constructor() { }



	static HTTP_RESPONSE = {
		OK: 200,
		UNAUTHORIZED: 401,
		DEVIATIONS: 412,
		PRECAUTION_REQUIRED: 428,
		BAD_RESPONSE: 422,
		NO_DATA_FOUND: 100,
		INTERNAL_SERVER_ERROR: 500,
		INVALID_ARGUMENT: 400,
		CONFIGURATION_ERROR: 5,
		DUPLICATE_RESULT: 4,
		COMMUNICATION_FAILURE: 6,
		SEARCH_COUNT_LIMIT_VIOLATED: 7,
		ENTITY_EXIST_EXCEPTION: 8,
		NADRA_SERVICE_ERROR: 9,
		ALREADY_EXIST: 10,
		BUSINESS_ERROR: 300,
		ACCOUNT_ERROR: 600,
		BLACKLISTED_ACCOUNT_ERROR: 601,
		UNVERIFIED_ACCOUNT: 602,
		NOT_FOUND: 404,
		NO_VALID_TRANSACTION: 400
	}

	static temporaryUniList = [
		{ "id": 10, "universityId": 17499, "allocatedSeat": 1000, "evaluationDate": 1632510000000, "universityName": "Karakurum International University, Gilgit, Gilgit Baltistan", "startDate": 1613329200000, "endDate": 1614452400000, "espProgramDegreeLevelList": [] },
	]

	static CONSTANT_VALUES = {
		maxSize: 2045,
		fileExt: 'jpg, jpeg, png, pdf',
		imageFileExt: 'jpg, jpeg, png',
		fileAllowedFormat: /^[0-9_a-z-A-Z(.) ]+$/,
		Comments_Character_Allowed: 500,
		Alive_Status: 10031,
		Single_Marital_Status: 10021,
		Islam_Religion: 10271,
		PK_Country_Code: 1,
		Father_Status_Default: 0,
		Identity_Cnic_Type: 10282,
		Address_Type_Mailing: 10202,
		JMP_Pending: 209711,
		JMP_Assigned: 209712,
		JMP_Approved: 209713,
		JMP_Rejected: 209714,
		EPE_Assigned: 209715,
		EPE_Submitted: 209716,
		PC_Approved: 209717,
		PC_Rejected: 209718,
		PO_PE_Saved: 209719,
		FPP_PE_SAVED: 209720,
		JMP_Send_Back: 209721,
		PC_Send_Back: 209722,
		FPP_Approved: 209723,
		FPP_Rejected: 209724,
		FPP_SEND_BACK_TO_PE: 209725,
		MAX_TOTAL_MARKS: 9999,
		DEFAULT_IMG_PATH: '/assets/media/users/default.jpg',
	}



	static PANELS = {
		THEMATIC_PANEL: 'Resource View',
		PROJECT_PANEL: 'Project View'

	}


	static DROPDOWN_FILTER: any = [
		{ codeId: "Application ID", codeValue: "Application ID" },
		{ codeId: "PI Name", codeValue: "PI Name" },
		{ codeId: "PI University", codeValue: "PI University" },
		{ codeId: "Project Name", codeValue: "Project Name" },
		{ codeId: "Discipline", codeValue: "Discipline" },
		{ codeId: "Theme", codeValue: "Theme" },
		{ codeId: "Project Number", codeValue: "Project Number" }
	]


	static DROPDOWN_FILTER_USER_PROFILE: any = [
		{ codeId: "cnic", codeValue: "CNIC" },
		{ codeId: "email", codeValue: "Email" },

	]

	static DROPDOWN_CATEGORY_TYPE: any = [
		{ codeId: "Primary", codeValue: "Primary" },
		{ codeId: "Supplementary", codeValue: "Supplementary" },

	]



	static ASSIGNMENT_CATEGORIES = {
		PO_ASSIGNMENT: 'PO Assignment',
		FPP_ASSIGNMENT: 'FPP Assignment',
		JMP_ASSIGNMENT: 'JMP Assignment',
		EPE_ASSIGNMENT: 'HLEP Assignment',
	}

	static ASSIGNMENT_ARTIFACT_ID = {
		PO_ASSIGNMENT: 300104,
		FPP_ASSIGNMENT: 300105,
		JMP_ASSIGNMENT: 300106,
		EPE_ASSIGNMENT: 300107,
	}

	static STATUS_ARTIFACT_ID = {
		PO_STATUS: 300118,
		FPP_STATUS: 300119,
		JMP_STATUS: 300120,
		EPE_STATUS: 300121,
	}


	static STATUS_CATEGORIES = {
		PO_STATUS: 'PO Status',
		FPP_STATUS: 'FPP Status',
		JMP_STATUS: 'JMP Status',
		EPE_STATUS: 'HELP Status',
	}

	static ERROR_MESSGAES = {
		AuthMessages: {
			INVALID_ACCOUNT: 'Invalid cnic or passport.',
			LOCKED_ACCOUNT: 'Your account is locked due to unsuccessful attempts to enter incorrect password. Please click on “Forget Password” and retrieve your password. In future please be careful while entering your password”.',
			UNVERIFIED_ACCOUNT: 'Your Account is not verified,please contact the administrator.',
			BLACKLISTED_ACCOUNT: 'Your account has been locked. Kindly contact call center (051-111-119-432) or online help (onlinehelp.hec.gov.pk) and register your complaint for support.',
			Invalid_Login: 'Invalid cnic or password',
			INVALID_PASSWORD: 'Invalid password',
			// OPT_SUCCESS_CODE: 'Enter OTP Code sent to your registered Email Address and Mobile Phone',
			OPT_SUCCESS_CODE: 'Enter OTP Code sent to your registered Email Address',
			EMAIL_ALREADY_REGISTERED: 'Email is already registered',
			CELL_ALREADY_REGISTERED: 'Cell Phone is already registered',
			EMAIL_CELL_ALREADY_REGISTERED: 'Email and Cell Phone is already registered',
			CELL_PHONE_CODE_RESEND: 'Cell Phone Verification Code is Resent',
			EMAIL_CODE_RESEND: 'Email Verification Code is Resent',
			PHONE_NUMBER_CODE_INVALID: 'Phone Number Authentication Code is not correct',
			EMAIL_CODE_INVALID: 'Email Authentication Code is not correct',
			ACCOUNT_CREATED: 'Your account has been successfully registered. Please use your registered CNIC/Passport to login',
			CNIC_ALREADY_REGISTER: 'CNIC is already registered. Please use a different one',
			POC_ALREADY_REGISTER: 'POC is already registered. Please use a different one',
			PASSPORT_ALREADY_REGISTER: 'Passport is already registered. Please use a different one',
			OVERSEAS_PAKISTANI_WARNING: 'Warning: Overseas and dual national Pakistanis must select "Pakistan" as their Country of Nationality',
			VERIFICATION_CODE_SENT: 'Verification Code is sent',
			FORGETPASSWORD_VERIFICATION_CODE_SENT: 'Verification Code sent to ',
			EMAIL_NOT_EXIST: 'Email address doesn\'t exist',
			CNIC_PASSPORT_NOT_EXIT: 'CNIC/Passport address doesn\'t exist',
			CELL_NOT_EXIT: 'Cell Number doesn\'t exist',
			VERIFICATION_RESEND: 'Verification Code is Resent',
			AUTHENTICATION_INVALID: 'Authentication code is not valid',
		},
		AppSchedulingMessages: {
			ERROR_CANCELLING_APP: 'Error in Cancelling Appointment',
			SUBMISSION_ERROR: 'Error in Submission Schedulling, please try again'
		},
		profileMessages: {
			NATIONALITY_REQUIRED: 'Primary Nationality is Required',
			ERROR_SAVING_ADDRESS: 'Error in saving address',
			ERROR_PROFILE: 'Error in saving profile',
			PROFILE_PICTURE_ERROR: 'Profile Picture is required',
			UPLOAD_PICTURE_ERROR: 'Error in uploading profile picture',
			UPDATE_EMAIL_REQ: 'Verification Code is sent to your entered email address, Enter verification code below',
			ALREADY_EXISTS_EMAIL: 'An account with this email address is already exists',
			EMAIl_UPDATE_SUCCESS: 'Email is updated successfully',
			AUTHENTICATION_CODE_INVALID: 'Authentication Code is not correct',
			PASSWORD_WARNING: 'Once your password is updated, you will be logged out of Scholarship Portal! You will need to Sign In back with the updated password.',
			OLD_PASSWORD_INVALID: 'Your old password is not correct',
			UPDATE_PHONE_REQ: 'Verification Code is sent to your entered mobile number, Enter verification code below',
			ALREADY_EXISTS_PHONE: 'An account with this mobile number is already exists',
			PHONE_UPDATE_SUCCESS: 'Phone Number is updated successfully',
			ADDRESS_UPDATED_SUCCESS: 'Your Address has been successfully updated',
			ERROR_EDUCATION_DELETE: 'Error in deleting Education',
			EDUCATION_SUCCESS: 'Education Update Successfully',
			PROFILE_UPDATED_SUCCESS: 'Your profile has been successfully updated'
		},
		ApplicationFormMessages: {
			QUESTIONNAIR_SAVED: 'Your Application is saved and can be access from "My Application" section from dasbboard'
		},
		VERIFICATION_CODE_SENT: 'Verification code has been sent to your E-mail',
		EMAIL_CODE_NOT_VALID: 'Email verification code is not valid',
		SMS_CODE_NOT_VALID: 'SMS verification code is not valid',
		CODES_NOT_VALID: 'Email verification code is not valid, SMS verification code is not valid',
		SMS_CODE_SENT: 'Cell Phone Verification Code Sent',
		EMAIL_CODE_SENT: 'Email Verification Code Sent',
		USERID_NOT_EXIST: 'User ID address doesn\'t exist',
		PASSWORD_UPDATED: 'Password is updated Successfully',
		SOMETHING_ERROR: 'Something went wrong!',
		SOMETHING_LATER_ERROR: 'Something went wrong, please try later',
		MANDATORY_DECISION: 'Decision must be selected while submitting application',
		QuestionnaireMessage: {
			NOT_ELIGIBLE: 'you are not eligible to apply in this scholarship program.'
		},
		SOMETHING_WENT_WRONG: 'Something Went Wrong',
	}

	static Application_Statuses = {
		Appintment_Booked: 600111,
		Status_Booked: 600101,
		Scheduling_Username_Type: 600191,
		COI_Identified: 209703,
		Submitted_By_Reviewer: 209704,
		All_reviewers_submitted: 209705,
		PO_PE_Submitted: 209706,
		PO_Rejected: 209707,
		Approved_for_FPP: 209708,
		FPP_PE_Submitted: 209709,
		FPP_PE_Rejected: 2097010,
		JMP_Pending: 209711,
		JMP_Assigned: 209712,
		JMP_Approved: 209713,
		JMP_Rejected: 209714,
		EPE_Assigned: 209715,
		EPE_Submitted: 209716,
		PC_Approved: 209717,
		PC_Rejected: 209718,
		PO_PE_Saved: 209719,
		FPP_PE_SAVED: 209720,
		JMP_Send_Back: 209721,
		PC_Send_Back: 209722,
		FPP_Approved: 209723,
		FPP_Rejected: 209724,
		FPP_SEND_BACK_TO_PE: 209725,
	}

	static Scheduling_Submission_Types = {
		self: 60032,
		authorize_persion: 60031,
		courier: 60033,
	}

	static Evaluation_Types = {
		PANEL_CHAIR: 'panelEvaluator',
		PROGRAM_CHAIR: 'programChair',
		JMP_CHAIR: 'jmp',
		STEERING_CHAIR: 'steering',
		HLEP: 'Hlep'
	}

	static ERROR_TYPES = {
		error: 'error',
		success: 'success',
		warning: 'warning',
		FPP_REVIEW: 'fppRevision'
	}

	static Shortlisting_Statuses = {
		Saved_By_Officer: 209101,
		Submitted: 209102,
		Saved_By_Approver: 209103,
		Approved: 209104,
		Rejected: 209105,
		Returned: 209106
	}

	static UserRoles = {
		ASSISTANT: "ASSISTANT",
		FINANCE: "FINANCE",
		AD: "AD",
		DD: "DD",
		DIR: "DIR",
		ED: "ED"
	}

	static DateFormat = {
		DD_MMM_YYYY: 'DD MMM YYYY'
	}

	static ScrutinyDecisions = [
		{ key: 600254, value: 'Approve' },
		{ key: 600255, value: 'Reject' },
		{ key: 600256, value: 'Revision Required' },
	];

	static ADDecisions = [
		{ key: 600257, value: 'Approve' },
		{ key: 600258, value: 'Reject' },
		{ key: 600259, value: 'Revision Required' },
		{ key: 6002510, value: 'Forward' },
	];

	static DDDecisions = [
		{ key: 6002511, value: 'Approve' },
		{ key: 6002512, value: 'Reject' },
		{ key: 6002513, value: 'Revision Required' },
		{ key: 6002514, value: 'Forward' },
	];

	static DirectorDecisions = [
		{ key: 6002515, value: 'Approve' },
		{ key: 6002516, value: 'Reject' },
		{ key: 6002517, value: 'Revision Required' },
		{ key: 6002518, value: 'Forward' },
	];

	static EDDecisions = [
		{ key: 6002519, value: 'Approve' },
		{ key: 6002520, value: 'Reject' },
		{ key: 6002521, value: 'Revision Required' },
	];

	static FinanceDecisions = [
		{ key: 6002522, value: 'Approve' },
		{ key: 6002523, value: 'Reject' },
	];

	static DesTaskTitles = {
		Scrutiny: "SCRUTINY",
		ADApproval: "AD APPROVAL",
		DDApproval: "DD APPROVAL",
		DIRApproval: "DIR APPROVAL",
		EDApproval: "ED APPROVAL",
		FinanceApproval: "FINANCE APPROVAL"
	}

	static EMP_ORGANIZATION_TYPE = {
		Academic: 10211,
		Professional: 10212,
	};

	static EMP_P_SECTOR = {
		Public: 10251,
		Private: 10252,
	};

	static EMP_A_SECTOR = {
		Public: 100,
		Private: 101,
	};

	static EMP_TEACHING_EXP = {
		Teaching: 10661,
		NonTeaching: 10662,
		Researcher: 10663,
	};

	static US_CITIZEN_SHIP_STATUS_LIST = [
		{
			label: 'US-Citizen',
			value: "12661"
		},
		{
			label: 'Registered U.S Permanent Resident',
			value: "12662"
		},
		{
			label: 'Non-Citizen',
			value: "12663"
		}
	];

	static US_CITIZENSHIP_STATUS = {
		USCitizen: "12661",
		Permanent: "12662",
		NonCitizen: "12663",
	};

	static SECTION_FIELD_RESOURCE_CODES = {
		FIELD_DISCIPLINE_PROPOSED_SEARCH: 10001,
		FIELD_SUB_DISCIPLINE: 10002,
		FIELD_SUB_FIELD: 10003,
		FIELD_THEME_OF_PROPOSED_RESEARCH: 10004,
		FIELD_SDG_GOALS: 10005,
		FIELD_PRIORITY_SECTOR: 10006,
		FIELD_LOCALLY_RELEVANT_SOCIO_ECONOMIC_ISSUE: 10007,
		SECTION_DECLARATION_CERTIFICATE: 50001,
		SECTION_FULL_PROJECT_PROPOSAL: 50002,
		SECTION_ENDORSEMENT_CERTIFICATE: 50003,
	};

	static APP_FORM_VIEWS = {
		FORM_EDIT: 'edit',
		FORM_VIEW: 'view',
		FORM_DOWNLOAD: 'download',
	};

	static TAB_HEADINGS = {
		COVER_SHEET: 0,
		COLLABORATING_ORGANIZATIONS: 1,
		BUDGET_1: 2,
		SUB_AWARD_BUDGET_1: 3,
		UPLOAD_DOCUMENTS: 4,
	};

	static DOC_DOWNLOAD_TYPES = {
		PROJECT_PROPOSAL: 100101,
		ENDORSEMENT: 100102,
		DECLARATION_CERTIFICATE: 100103,
	};

	static PUCA_DOC_UPLOAD_DROPDOWNS = [
		{
			label: 'CV',
			value: 14661,
			isMandatory: true,
			uploadDescription: 'CV'
		},
		{
			label: 'Statement of Purpose',
			value: 14662,
			isMandatory: true,
			uploadDescription: 'Statement of Purpose'
		},
		{
			label: 'Research Proposal',
			value: 14663,
			isMandatory: true,
			uploadDescription: 'Research Proposal'
		},
		{
			label: 'Copy of Last Degree',
			value: 14664,
			isMandatory: true,
			uploadDescription: 'Copy of Last Degree'
		},
		{
			label: 'Copy of Last Transcript',
			value: 14665,
			isMandatory: true,
			uploadDescription: 'Copy of Last Transcript'
		},
		{
			label: 'Copy of Relevant Official Score Card',
			value: 14666,
			isMandatory: true,
			uploadDescription: 'Copy of Relevant Official Score Card'
		},
		{
			label: 'Copy of CNIC',
			value: 14667,
			isMandatory: true,
			uploadDescription: 'Copy of CNIC'
		},
	];

	static PUCA_NEW_DOC_UPLOAD_DROPDOWNS = [
		{
			label: 'CV',
			value: 14661,
			isMandatory: true,
			uploadDescription: 'CV'
		},
		{
			label: 'Statement of Purpose',
			value: 14662,
			isMandatory: true,
			uploadDescription: 'Statement of Purpose'
		},
		{
			label: 'Research Proposal',
			value: 14663,
			isMandatory: true,
			uploadDescription: 'Research Proposal'
		},
		{
			label: 'Copy of Last Degree',
			value: 14664,
			isMandatory: true,
			uploadDescription: 'Copy of Last Degree'
		},
		{
			label: 'Copy of Last Transcript',
			value: 14665,
			isMandatory: true,
			uploadDescription: 'Copy of Last Transcript'
		},
		{
			label: 'Copy of Relevant Official Score Card',
			value: 14666,
			isMandatory: true,
			uploadDescription: 'Copy of Relevant Official Score Card'
		},
		{
			label: 'Copy of CNIC',
			value: 14667,
			isMandatory: true,
			uploadDescription: 'Copy of CNIC'
		},
		{
			label: 'University Rank List',
			value: 14668,
			isMandatory: true,
			uploadDescription: 'University Rank List'
		},
	];

	static PUCA_CONSTANTS = {
		PERCENTAGE_OUT_OF: 370,
		TERM_AND_CONDITION_ERROR: "Please click on checkbox to agree on terms & conditions "
	}

	static PUCA_SEMESTER_LIST = [
		{
			label: 'FALL',
			value: 30431,
		},
		{
			label: 'SPRING',
			value: 30432,
		},
		{
			label: 'SUMMER',
			value: 30433,
		},
	]

	static PUCA_NEW_SEMESTER_LIST = [
		// {
		// 	label: 'FALL',
		// 	value: 30431,
		// },
		// {
		// 	label: 'SPRING',
		// 	value: 30432,
		// },
		{
			label: 'SUMMER',
			value: 30433,
		},
	]

	static PUCA_SEMESTER_YEAR_LIST = [
		{
			label: '2001',
			value: 2001,
		}, {
			label: '2002',
			value: 2002,
		}, {
			label: '2003',
			value: 2003,
		}, {
			label: '2004',
			value: 2004,
		}, {
			label: '2005',
			value: 2005,
		}, {
			label: '2006',
			value: 2006,
		}, {
			label: '2007',
			value: 2007,
		}, {
			label: '2008',
			value: 2008,
		}, {
			label: '2009',
			value: 2009,
		}, {
			label: '2010',
			value: 2010,
		}, {
			label: '2011',
			value: 2011,
		}, {
			label: '2012',
			value: 2012,
		}, {
			label: '2013',
			value: 2013,
		}, {
			label: '2014',
			value: 2014,
		}, {
			label: '2015',
			value: 2015,
		}, {
			label: '2016',
			value: 2016,
		}, {
			label: '2017',
			value: 2017,
		}, {
			label: '2018',
			value: 2018,
		}, {
			label: '2019',
			value: 2019,
		}, {
			label: '2020',
			value: 2020,
		}, {
			label: '2021',
			value: 2021,
		}, {
			label: '2022',
			value: 2022,
		}
	]

	static PUCA_NEW_SEMESTER_YEAR_LIST = [
		{
			label: '2023',
			value: 2023,
		}
	]

	static PUCA_AOR_LIST = [
		{
			label: 'TEST AREA OF RESEARCH 1',
			value: 1,
		},
		{
			label: 'TEST AREA OF RESEARCH 2',
			value: 2,
		},
		{
			label: 'TEST AREA OF RESEARCH 3',
			value: 3,
		},
	]

	static disciplineFields = [

		{
			"label": "Agriculture",
			"value": 27
		},
		{
			"label": "Arts & Humanities",
			"value": 28
		},
		{
			"label": "Biological Sciences",
			"value": 29
		},
		{
			"label": "Engineering & Technology",
			"value": 30
		},
		{
			"label": "Management Sciences & Business Education",
			"value": 31
		},
		{
			"label": "Medical Sciences",
			"value": 32
		},
		{
			"label": "Physical Sciences",
			"value": 33
		},
		{
			"label": "Social Sciences",
			"value": 34
		},
		{
			"label": "Veterinary Sciences",
			"value": 35
		}

	]
}
